import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Button, Form, Icon, Input } from 'antd';

import { updateUser } from '../../services/user/actions';
import * as actions from './services/loginFeedback/actions';
import logo from './logo.png';
import './LoginPage.scss';

const API_URL = process.env.API_URL;
const FormItem = Form.Item;

export class LoginPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isLoggingIn: false
        }
    }

    handleSubmit(e) {
        const { form, updateErrorMessage, updateUser } = this.props
        e.preventDefault();
        this.setState({ isLoggingIn: true });
        updateErrorMessage('');

        form.validateFields((err, values) => {
            if (!err) {
                fetch(`${API_URL}/auth/login`, {
                        method: 'POST',
                        mode: 'cors',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(values)
                    })
                    .then((res) => res.json())
                    .then((json) => {
                        if (json.error)
                            updateErrorMessage(json.error.message);
                        else {
                            updateUser({ id: json.id, name: json.name, isAdmin: json.is_admin });
                            localStorage.setItem('jwt', json.jwt);
                        }
                        this.setState({ isLoggingIn: false });
                    })
            }
        });
    }

    render() {
        const { form, errorMessage } = this.props;
        const { isLoggingIn } = this.state;
        const { getFieldDecorator } = form;
        const jwt = localStorage.getItem('jwt');

        if (jwt)
            return <Redirect to="/dashboard"/>;
        else
            return (
                <div className="LoginPage">
                    <div className="LoginPage-container">
                        <div className="LoginPage-logo-container">
                            <img className="LoginPage-logo" src={logo} alt="Informatics Logo"/>
                        </div>
                        <div className="LoginPage-form-container">
                            <p className="error-message">{errorMessage}</p>
                            <Form className="LoginPage-form" onSubmit={(e) => this.handleSubmit(e)}>
                                <FormItem>
                                    {getFieldDecorator('username', {
                                        rules: [{ required: true, message: 'Please input your username!' }],
                                    })(
                                        <Input 
                                            prefix={<Icon type="user" style={{ fontSize: 13 }} />} 
                                            placeholder="Username" 
                                        />
                                    )}
                                </FormItem>
                                <FormItem>
                                    {getFieldDecorator('password', {
                                        rules: [{ required: true, message: 'Please input your Password!' }],
                                    })(
                                        <Input 
                                            prefix={<Icon type="lock" style={{ fontSize: 13 }} />} 
                                            type="password" 
                                            placeholder="Password"
                                        />
                                    )}
                                </FormItem>
                                <FormItem>
                                    <Button type="primary" htmlType="submit" className="login-form-button" loading={isLoggingIn}>Log in</Button>
                                </FormItem>
                            </Form>
                        </div>
                    </div>
                </div>
            );
    }
}

const mapStateToProps = (state) => {
    return {
        errorMessage: state.loginFeedback.errorMessage
    }
}

const WrappedLoginPage = Form.create()(LoginPage);
export default connect(mapStateToProps, { ...actions, updateUser })(WrappedLoginPage);


// WEBPACK FOOTER //
// ./src/scenes/LoginPage/LoginPage.js